/** FuryBot analytics — sessionStorage-based event tracking */
export const track = (event, data = {}) => {
  const entry = { event, ...data, timestamp: new Date().toISOString(), page: window.location.pathname, device: window.innerWidth < 768 ? "mobile" : "desktop" };
  const logs = JSON.parse(sessionStorage.getItem("furybot_analytics") || "[]");
  logs.push(entry);
  sessionStorage.setItem("furybot_analytics", JSON.stringify(logs.slice(-200)));
};

/** Query intelligence log — tracks what traders ask for intent analysis */
export const logQuery = (query, intent, firmSlug) => {
  const logs = JSON.parse(sessionStorage.getItem("fury_query_log") || "[]");
  logs.push({ query: query.substring(0, 200), intent: intent || "unknown", firm: firmSlug || null, ts: Math.floor(Date.now() / 1000) });
  sessionStorage.setItem("fury_query_log", JSON.stringify(logs.slice(-200)));
};
